<template>
  <select
    @blur="handleBlur"
    @change="handleChange"
    @input="handleInput"
    class="fy-select"
    v-model="currentValue"
  >
    <option value></option>
    <option :key="index" :value="item[valueKey]" v-for="(item,index) in options">{{item[labelKey]}}</option>
  </select>
</template>
<script>
import util from "../utils/util.js";
export default {
  name: "FySelect",
  componentName: "FySelect",
  mixins: [util], //这些混入实例对象可以像正常的实例对象一样包含选项（可以直接this.*使用混入对象中的方法）
  inject: {
    fyForm: {
      default: ""
    },
    fyFormItem: {
      default: ""
    }
  },
  data () {
    return {
      currentValue:
        this.value === undefined || this.value === null ? "" : this.value
    };
  },
  props: {
    value: [String, Number],
    options: {
      type: Array,
      default: function () {
        return [];
      }
    },
    labelKey: String,
    valueKey: String
  },
  watch: {
    //在input子组件中不能直接改变在外部双向绑定的value
    value (value) {
      this.currentValue = value;
      this.$emit("input", value);
    }
  },
  mounted () {
    this.dispatch("FyFormItem", "formItem.addChildVc", [this]); //发送添加formitem对象的信息
  },
  methods: {
    resetField () {
      this.$emit("input", '');
    },
    handleInput (event) {
      const value = event.target.value;
      this.$emit("input", value);  //发送value的值给formitem
    },
    //Change触发事件还有问题
    handleChange (event) {
      const value = event.target.value;
      this.$emit("input", value);
      this.dispatch("FyFormItem", "el.form.change", [value]);
    },
    handleBlur (event) {
      const value = event.target.value;
      this.dispatch("FyFormItem", "el.form.blur", [value]);
    },
  }
};
</script>
<style scoped>
@import '../../assets/css/components/form/form.css';
</style>



// WEBPACK FOOTER //
// src/components/form/select.vue